const ImagesCards = ({ images, isNews = false }) => {
  return (
    <div className="mx-auto max-w-7xl pt-20 px-4 sm:px-6 lg:px-8">
      <div className="space-y-12">
        <ul
          role="list"
          className="space-y-4 sm:grid sm:grid-cols-2 gap-x-4 gap-y-10 sm:space-y-0 lg:grid-cols-4 mt-5 mb-10"
        >
          {images.map((gallery, idx) => {
            const bgColor = gallery?.color || 'bg-blue'
            return (
              <li key={idx}>
                <a className="group" href={gallery.link}>
                  <div className="aspect-w-3 aspect-h-3">
                    <img className="object-cover" src={gallery.image} alt="" />
                    <div
                      className={`transition duration-300 ease-in-out group-hover:${bgColor} opacity-80`}
                    ></div>
                    <div className="absolute justify-center items-center pointer-events-none hidden group-hover:flex">
                      <p className="text-3xl font-alliance-medium text-white">
                        Ves-hi
                      </p>
                      <img
                        src="/assets/link-arrow-white.svg"
                        alt=""
                        className="pointer-events-none object-fill w-12 ml-5"
                      />
                    </div>
                  </div>
                  {/* {gallery.Name && (
                    <div className={`transition-colors ease-out bg-sec-blue`}>
                      <div className="flex space-y-1 text-md font-alliance-medium leading-6">
                        <p className="text-black p-3">{gallery.Name}</p>
                      </div>
                    </div>
                  )} */}
                  <div key={gallery.name} className="flex flex-col capitalize">
                    <div className="flex flex-1 flex-col justify-between">
                      <div className="flex-1">
                        <p
                          className={`mt-3 font-alliance-medium text-gray-900 capitalize ${
                            isNews ? 'text-xl' : 'text-3xl'
                          }`}
                        >
                          {gallery.name}
                        </p>
                      </div>
                      <div className="mt-4 flex items-center">
                        <div className="flex-shrink-0">
                          <span className="sr-only">{gallery.date}</span>
                        </div>
                        <div className="">
                          <p className="text-[18px] font-alliance-medium text-blue">
                            {gallery.date}
                          </p>
                          {/* <div className="flex space-x-1 text-[18px] font-alliance-medium text-blue opacity-40">
                            {gallery.date}
                          </div> */}
                        </div>
                        {/* {gallery.link && (
                          <a
                            href={gallery.link}
                            className="h-10 w-10 rounded-full ml-auto bg-sec-grey-4 flex hover:bg-accent"
                          >
                            <img
                              className="object-fill m-[10px]"
                              src="/assets/download.svg"
                              alt=""
                            />
                          </a>
                        )} */}
                      </div>
                    </div>
                  </div>
                </a>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default ImagesCards
